import FormClient from "./FormClient";

export default function HistoryFormPage() {
    return <FormClient />;
}

